export const PHONENUMBER_MASK = '(+64) 99999999999';
export const PHONENUMBER_PLACEHOLDER = '(+64)            ';
export const DEFAULT_ERROR_MESSAGE = 'This field is required';
export const BIRTHDATE_MASK = '99/99/9999';
export const DISCLAIMER_DESCRIPTION = 'Already have a Living Rewards card, but no online membership access?';
export const DISCLAIMER_LINK = 'Register your Living Rewards card here.';
export const EMAIL_FORMAT_ERROR = 'Entered value does not match email format';
export const AGE_BIRTHDATE_VALIDATION_ERROR = 'The user must be 13 years old and over';
export const PASSWORD_DISCLAIMER = 'Please choose a password with at least 8 <br /> characters and must contain 1 uppercase letter,<br />1 lowercase letter and 1 unique character.';